var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 799,
    height: 660,
    viewBox: "0 0 799 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_106_181",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 800,
    height: 660
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1 0H799V660H-1V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_106_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.3698 0C38.6145 0 -0.473999 39.0885 -0.473999 86.8438V573.156C-0.473999 621.115 38.4166 660 86.3698 660H711.63C759.583 660 798.474 621.115 798.474 573.156V86.8438C798.474 39.0885 759.385 0 711.63 0H86.3698ZM86.3698 34.7344H711.63C740.609 34.7344 763.734 57.8646 763.734 86.8438V122.089C749.161 111.031 731.224 104.208 711.63 104.208H86.3698C66.776 104.208 48.8385 111.031 34.2656 122.089V86.8438C34.2656 57.8646 57.3906 34.7344 86.3698 34.7344ZM86.3698 138.948H711.63C740.609 138.948 763.734 162.073 763.734 191.052V226.297C749.161 215.245 731.224 208.422 711.63 208.422H86.3698C66.776 208.422 48.8385 215.245 34.2656 226.297V191.052C34.2656 162.073 57.3906 138.948 86.3698 138.948ZM86.3698 243.156H711.63C740.609 243.156 763.734 266.286 763.734 295.266V330H583.37C545.714 330 511.286 351.276 494.458 384.953L487.943 397.948C471.078 431.625 436.672 452.901 399 452.901C361.328 452.901 326.917 431.625 310.089 397.948L303.609 384.953C286.76 351.26 252.302 330 214.63 330H34.2656V295.266C34.2656 266.286 57.3906 243.156 86.3698 243.156Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 799,
    height: 660,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet2);
export default __webpack_public_path__ + "static/media/wallet2.1c1edf0ec37d18a1ef2d10be13107105.svg";
export { ForwardRef as ReactComponent };